import { useLocation, useNavigate } from "react-router-dom";
import useAuthentication from "../../../hooks/useAuthentication";
import { useForm } from "react-hook-form";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useMutation } from "react-query";
import { saveMasterData } from "./services";
import { useEffect } from "react";
import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const pageTitle = "Country ";
function AddOrEditCountry() {
  const { user } = useAuthentication();
  const navigate = useNavigate();
  const { control, handleSubmit, reset } = useForm<MasterFormDataType>({
    defaultValues: initialFormData,
  });
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };
  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.responseMessage ||
          e?.response?.data?.errorMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: MasterFormDataType) => {
    console.log("onSubmit--->",{
      ...value,
      clinicId: Number(user?.clinicId),
      createdById: Number(user?.userId),
      countryId: data?.countryId || 0,
    });
    save([
      {
        ...value,
        isoCode:value.isoCode,
        clinicId: Number(user?.clinicId),
        createdById: Number(user?.userId),
        countryId: data?.countryId || 0,
      },
    ]);
  };

  const handleReset = () => {
    reset(initialFormData);
  };

  useEffect(() => {
    if (data) {
      reset({...data});
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="countryCode"
              element="input"
              fieldProps={{ label: "Enter country code " }}
              rules={{ required: "country code is required" }}
            />
            <CustomFormField
              control={control}
              name="isoCode"
              element="input"
              fieldProps={{ label: "Enter ISO code " }}
              rules={{ required: "ISO code is required" }}
            />
            <CustomFormField
              control={control}
              name="nationality"
              element="input"
              fieldProps={{ label: "Nationality " }}
              rules={{ required: "Nationality is required" }}
            />
            <CustomFormField
              control={control}
              name="countryName"
              element="input"
              fieldProps={{ label: "Enter country name " }}
              rules={{ required: "Name is required" }}
            />
            <CustomFormField
              control={control}
              name="countryStatus"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "Status is required" }}
            />
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEditCountry;
